import { render, staticRenderFns } from "./TotalTracingCard.vue?vue&type=template&id=19ffd2e2&scoped=true"
import script from "./TotalTracingCard.vue?vue&type=script&lang=js"
export * from "./TotalTracingCard.vue?vue&type=script&lang=js"
import style0 from "./TotalTracingCard.vue?vue&type=style&index=0&id=19ffd2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ffd2e2",
  null
  
)

export default component.exports